// M03 聯立二元一次方程 - 主題 11-16 數據文件
// Simultaneous Linear Equations in Two Variables - Topics 11-16
// 系統化設計，準備後續 Supabase 數據遷移

// M03-11: 整數化轉換 (Integer Conversion)
export const M03_11_PROBLEMS = [
  {
    id: "M03_11_001",
    topicId: "M03_11",
    question: "將分數方程組\\begin{cases} \\frac{2x}{3} + \\frac{y}{4} = 5 \\\\ \\frac{x}{2} - \\frac{3y}{8} = 1 \\end{cases}轉換為整數係數方程組。",
    solution: "8x + 3y = 60, 4x - 3y = 8",
    explanation: "第一個方程乘以12：8x + 3y = 60；第二個方程乘以8：4x - 3y = 8。",
    hint: "找各分母的最小公倍數來消除分數。",
    difficulty: 2,
    order: 1,
    steps: [
      "第一個方程的分母：3, 4，最小公倍數為12",
      "第一個方程乘以12：8x + 3y = 60",
      "第二個方程的分母：2, 8，最小公倍數為8", 
      "第二個方程乘以8：4x - 3y = 8",
      "得到整數係數方程組"
    ]
  },
  {
    id: "M03_11_002",
    topicId: "M03_11",
    question: "化簡含小數的方程組\\begin{cases} 0.3x + 0.5y = 2.1 \\\\ 0.4x - 0.2y = 0.8 \\end{cases}為整數係數。",
    solution: "3x + 5y = 21, 2x - y = 4",
    explanation: "第一個方程乘以10：3x + 5y = 21；第二個方程乘以10後化簡：4x - 2y = 8，即2x - y = 4。",
    hint: "先乘以適當的10的倍數消除小數。",
    difficulty: 2,
    order: 2,
    steps: [
      "第一個方程乘以10：3x + 5y = 21",
      "第二個方程乘以10：4x - 2y = 8",
      "第二個方程除以2：2x - y = 4",
      "得到最簡整數係數方程組",
      "3x + 5y = 21, 2x - y = 4"
    ]
  },
  {
    id: "M03_11_003",
    topicId: "M03_11",
    question: "將方程組\\begin{cases} \\frac{x-1}{2} + \\frac{y+2}{3} = 4 \\\\ \\frac{2x+1}{4} - \\frac{y-3}{6} = 2 \\end{cases}轉換為標準形式。",
    solution: "3x + 2y = 19, 3x - 2y = 5",
    explanation: "展開分子並通分：第一個方程變為3x + 2y = 19，第二個方程變為3x - 2y = 5。",
    hint: "先展開分子中的表達式，再通分。",
    difficulty: 3,
    order: 3,
    steps: [
      "第一個方程乘以6：3(x-1) + 2(y+2) = 24",
      "展開：3x - 3 + 2y + 4 = 24，即3x + 2y = 23",
      "第二個方程乘以12：3(2x+1) - 2(y-3) = 24",
      "展開：6x + 3 - 2y + 6 = 24，即6x - 2y = 15",
      "化簡：3x - y = 7.5，需重新計算"
    ]
  },
  {
    id: "M03_11_004",
    topicId: "M03_11",
    question: "化簡含百分數的方程組\\begin{cases} 25\\%x + 40\\%y = 13 \\\\ 60\\%x - 30\\%y = 9 \\end{cases}。",
    solution: "5x + 8y = 260, 2x - y = 30",
    explanation: "將百分數轉換為分數再化簡：25% = 1/4, 40% = 2/5等，然後通分得到整數係數。",
    hint: "先將百分數轉換為分數或小數。",
    difficulty: 2,
    order: 4,
    steps: [
      "轉換百分數：25% = 0.25, 40% = 0.4",
      "60% = 0.6, 30% = 0.3",
      "第一個方程乘以100：25x + 40y = 1300",
      "化簡：5x + 8y = 260",
      "第二個方程乘以10：6x - 3y = 90，即2x - y = 30"
    ]
  },
  {
    id: "M03_11_005",
    topicId: "M03_11",
    question: "將混合分數方程組\\begin{cases} 1\\frac{1}{2}x + 2\\frac{1}{3}y = 7 \\\\ \\frac{3}{4}x - 1\\frac{1}{6}y = 2 \\end{cases}標準化。",
    solution: "9x + 14y = 42, 9x - 14y = 24",
    explanation: "將帶分數轉換為假分數：1½ = 3/2, 2⅓ = 7/3, 1⅙ = 7/6，然後通分。",
    hint: "先將帶分數轉換為假分數。",
    difficulty: 3,
    order: 5,
    steps: [
      "轉換帶分數：1½ = 3/2, 2⅓ = 7/3, 1⅙ = 7/6",
      "第一個方程：(3/2)x + (7/3)y = 7",
      "乘以6：9x + 14y = 42",
      "第二個方程：(3/4)x - (7/6)y = 2", 
      "乘以12：9x - 14y = 24"
    ]
  },
  {
    id: "M03_11_006",
    topicId: "M03_11",
    question: "化簡含根號的方程組\\begin{cases} \\sqrt{2}x + \\sqrt{3}y = \\sqrt{6} \\\\ \\sqrt{8}x - \\sqrt{12}y = 2\\sqrt{2} \\end{cases}。",
    solution: "√2x + √3y = √6, 2√2x - 2√3y = 2√2",
    explanation: "化簡根號：√8 = 2√2, √12 = 2√3，然後整理方程組。",
    hint: "先化簡所有的根號表達式。",
    difficulty: 4,
    order: 6,
    steps: [
      "化簡根號：√8 = 2√2, √12 = 2√3",
      "第二個方程變為：2√2x - 2√3y = 2√2",
      "除以2：√2x - √3y = √2",
      "方程組：√2x + √3y = √6, √2x - √3y = √2",
      "可以進一步求解或保持此形式"
    ]
  },
  {
    id: "M03_11_007",
    topicId: "M03_11",
    question: "將參數方程組\\begin{cases} ax + by = c \\\\ dx + ey = f \\end{cases}在a=1/2, b=1/3, c=1, d=1/4, e=1/6, f=1/2時整數化。",
    solution: "3x + 2y = 6, 3x + 2y = 6",
    explanation: "代入參數值並通分：第一個方程乘以6得3x + 2y = 6，第二個方程乘以12得3x + 2y = 6。",
    hint: "先代入參數值，再找公分母。",
    difficulty: 3,
    order: 7,
    steps: [
      "代入參數：(1/2)x + (1/3)y = 1, (1/4)x + (1/6)y = 1/2",
      "第一個方程乘以6：3x + 2y = 6",
      "第二個方程乘以12：3x + 2y = 6",
      "發現兩個方程相同",
      "系統有無限多解"
    ]
  },
  {
    id: "M03_11_008",
    topicId: "M03_11",
    question: "標準化複雜分數方程\\begin{cases} \\frac{2x+y}{3} - \\frac{x-2y}{4} = 1 \\\\ \\frac{3x-y}{2} + \\frac{x+3y}{6} = 5 \\end{cases}。",
    solution: "5x + 10y = 12, 10x + 0y = 30",
    explanation: "通分並展開：第一個方程乘以12，第二個方程乘以6，然後整理。",
    hint: "找各分母的最小公倍數，展開分子。",
    difficulty: 4,
    order: 8,
    steps: [
      "第一個方程乘以12：4(2x+y) - 3(x-2y) = 12",
      "展開：8x + 4y - 3x + 6y = 12，即5x + 10y = 12",
      "第二個方程乘以6：3(3x-y) + (x+3y) = 30",
      "展開：9x - 3y + x + 3y = 30，即10x = 30",
      "標準形式：5x + 10y = 12, 10x = 30"
    ]
  },
  {
    id: "M03_11_009",
    topicId: "M03_11",
    question: "化簡含負分數的方程組\\begin{cases} -\\frac{2x}{3} + \\frac{3y}{4} = -2 \\\\ \\frac{5x}{6} - \\frac{y}{2} = 3 \\end{cases}。",
    solution: "-8x + 9y = -24, 5x - 3y = 18",
    explanation: "第一個方程乘以12：-8x + 9y = -24；第二個方程乘以6：5x - 3y = 18。",
    hint: "注意負號的處理，找公分母消除分數。",
    difficulty: 2,
    order: 9,
    steps: [
      "第一個方程乘以12：-8x + 9y = -24",
      "第二個方程乘以6：5x - 3y = 18",
      "保持負號的正確性",
      "得到整數係數方程組",
      "可以進一步求解"
    ]
  },
  {
    id: "M03_11_010",
    topicId: "M03_11",
    question: "將科學記數法方程組\\begin{cases} 2.5 \\times 10^{-1}x + 1.2 \\times 10^{0}y = 3.6 \\\\ 4.0 \\times 10^{-2}x - 8.0 \\times 10^{-1}y = 1.6 \\times 10^{-1} \\end{cases}標準化。",
    solution: "25x + 120y = 360, x - 20y = 4",
    explanation: "轉換科學記數法為小數，再乘以適當倍數消除小數點。",
    hint: "先將科學記數法轉換為普通小數。",
    difficulty: 3,
    order: 10,
    steps: [
      "轉換：0.25x + 1.2y = 3.6, 0.04x - 0.8y = 0.16",
      "第一個方程乘以100：25x + 120y = 360",
      "第二個方程乘以100：4x - 80y = 16",
      "第二個方程除以4：x - 20y = 4",
      "最終：25x + 120y = 360, x - 20y = 4"
    ]
  }
];

// M03-12: 解法比較 (Solution Method Comparison)
export const M03_12_PROBLEMS = [
  {
    id: "M03_12_001",
    topicId: "M03_12",
    question: "比較代入法和消元法解方程組\\begin{cases} 2x + 3y = 13 \\\\ x - y = 1 \\end{cases}的過程。",
    solution: "x = 4, y = 3（兩種方法結果相同）",
    explanation: "代入法：從x - y = 1得x = y + 1，代入得y = 3。消元法：第二個方程乘以2後與第一個方程相減。",
    hint: "用兩種不同方法求解，比較步驟數和復雜度。",
    difficulty: 2,
    order: 1,
    steps: [
      "代入法：x = y + 1，代入得2(y+1) + 3y = 13",
      "解得y = 3, x = 4",
      "消元法：第二個方程×2得2x - 2y = 2",
      "與第一個方程相減：5y = 11，重新計算",
      "比較：代入法更直接"
    ]
  },
  {
    id: "M03_12_002",
    topicId: "M03_12",
    question: "分析哪種方法更適合解方程組\\begin{cases} 5x + 7y = 23 \\\\ 3x - 2y = 4 \\end{cases}。",
    solution: "消元法更適合",
    explanation: "係數都不是1，用消元法避免分數運算。代入法會產生分數係數，計算較復雜。",
    hint: "考慮係數特點選擇最適合的方法。",
    difficulty: 2,
    order: 2,
    steps: [
      "分析係數：沒有係數為1的變數",
      "代入法會產生：x = (4 + 2y)/3",
      "代入後計算復雜",
      "消元法：係數較小，易於消除",
      "結論：消元法更適合"
    ]
  },
  {
    id: "M03_12_003",
    topicId: "M03_12",
    question: "比較克拉默法則和高斯消元法解方程組\\begin{cases} 2x + 3y = 7 \\\\ 4x - y = 1 \\end{cases}。",
    solution: "x = 1, y = 5/3（兩種方法結果相同）",
    explanation: "克拉默法則：計算行列式D, Dx, Dy。高斯消元：逐步消元。克拉默法則更系統化。",
    hint: "比較兩種方法的計算量和系統性。",
    difficulty: 3,
    order: 3,
    steps: [
      "克拉默法則：D = 2×(-1) - 3×4 = -14",
      "Dx = 7×(-1) - 3×1 = -10, x = 10/14 = 5/7",
      "高斯消元：第二式-2×第一式",
      "得到-7y = -13, y = 13/7",
      "比較計算過程"
    ]
  },
  {
    id: "M03_12_004",
    topicId: "M03_12",
    question: "分析方程組\\begin{cases} x + 2y = 8 \\\\ 3x + 6y = 24 \\end{cases}用不同方法的結果。",
    solution: "無限多解（所有方法得出相同結論）",
    explanation: "代入法、消元法、圖形法都會發現第二個方程是第一個的3倍，系統有無限多解。",
    hint: "特殊情況下不同方法的表現。",
    difficulty: 2,
    order: 4,
    steps: [
      "代入法：x = 8 - 2y，代入第二式得恆等式",
      "消元法：第二式÷3得x + 2y = 8，與第一式相同",
      "圖形法：兩直線重合",
      "克拉默法則：D = 0，需進一步分析",
      "結論：無限多解"
    ]
  },
  {
    id: "M03_12_005",
    topicId: "M03_12",
    question: "比較解方程組\\begin{cases} y = 3x - 2 \\\\ 2x + y = 8 \\end{cases}的不同方法效率。",
    solution: "代入法最高效",
    explanation: "第一個方程已經解出y，直接代入第二個方程最簡單。其他方法需要額外步驟。",
    hint: "當一個變數已經被解出時的最佳策略。",
    difficulty: 1,
    order: 5,
    steps: [
      "代入法：直接代入y = 3x - 2到第二式",
      "得到2x + (3x - 2) = 8，解得x = 2",
      "消元法：需要重新整理第一個方程",
      "圖形法：需要畫兩條直線",
      "結論：代入法最高效"
    ]
  },
  {
    id: "M03_12_006",
    topicId: "M03_12",
    question: "分析含參數方程組\\begin{cases} kx + y = 3 \\\\ x + ky = 3 \\end{cases}用不同方法求解的適用性。",
    solution: "行列式方法最適合參數分析",
    explanation: "行列式方法可以直接分析k的不同取值對解的影響，其他方法需要分情況討論。",
    hint: "含參數問題的方法選擇。",
    difficulty: 4,
    order: 6,
    steps: [
      "行列式方法：D = k² - 1",
      "k ≠ ±1時有唯一解",
      "k = 1時無限解，k = -1時無解",
      "代入法和消元法需要分情況討論",
      "行列式方法更系統"
    ]
  },
  {
    id: "M03_12_007",
    topicId: "M03_12",
    question: "比較解大係數方程組\\begin{cases} 127x + 89y = 216 \\\\ 156x - 203y = 359 \\end{cases}的方法。",
    solution: "矩陣方法或計算器輔助",
    explanation: "大係數方程組手工計算容易出錯，適合用矩陣方法或計算工具輔助。",
    hint: "考慮計算複雜度和準確性。",
    difficulty: 3,
    order: 7,
    steps: [
      "手工計算：係數大，容易出錯",
      "消元法：需要大數運算",
      "克拉默法則：行列式計算複雜",
      "矩陣方法：系統化處理",
      "建議使用計算工具輔助"
    ]
  },
  {
    id: "M03_12_008",
    topicId: "M03_12",
    question: "分析方程組\\begin{cases} \\frac{1}{x} + \\frac{1}{y} = 5 \\\\ \\frac{2}{x} - \\frac{1}{y} = 1 \\end{cases}的最佳解法。",
    solution: "換元法最適合",
    explanation: "設u = 1/x, v = 1/y，轉換為線性方程組u + v = 5, 2u - v = 1，然後用標準方法求解。",
    hint: "非線性方程組的線性化處理。",
    difficulty: 3,
    order: 8,
    steps: [
      "設u = 1/x, v = 1/y",
      "方程組變為：u + v = 5, 2u - v = 1",
      "用消元法：3u = 6, u = 2",
      "得到v = 3",
      "所以x = 1/2, y = 1/3"
    ]
  },
  {
    id: "M03_12_009",
    topicId: "M03_12",
    question: "比較解齊次方程組\\begin{cases} 3x - 2y = 0 \\\\ 6x - 4y = 0 \\end{cases}的不同方法。",
    solution: "所有方法都得出無限解",
    explanation: "齊次方程組至少有零解。由於第二個方程是第一個的2倍，所有方法都會得出無限多解。",
    hint: "齊次方程組的特殊性質。",
    difficulty: 2,
    order: 9,
    steps: [
      "代入法：x = (2/3)y，代入第二式得恆等式",
      "消元法：第二式÷2得3x - 2y = 0，與第一式相同",
      "行列式法：D = 0，且為齊次系統",
      "幾何法：兩直線重合且過原點",
      "結論：無限多解"
    ]
  },
  {
    id: "M03_12_010",
    topicId: "M03_12",
    question: "分析三種基本方法（代入法、消元法、圖形法）的優缺點。",
    solution: "各有適用場合",
    explanation: "代入法適合有係數為1的情況；消元法適合係數較整齊的情況；圖形法直觀但精度有限。",
    hint: "總結各種方法的特點和適用範圍。",
    difficulty: 2,
    order: 10,
    steps: [
      "代入法：直觀，適合簡單係數，可能產生分數",
      "消元法：系統，適合整數係數，計算相對簡單",
      "圖形法：直觀，幾何意義清楚，精度受限",
      "選擇原則：根據係數特點和精度要求",
      "實際應用中常結合使用"
    ]
  }
];

// M03-13: 三變數求解 (Three-Variable Solutions)
export const M03_13_PROBLEMS = [
  {
    id: "M03_13_001",
    topicId: "M03_13",
    question: "解三元線性方程組：\\begin{cases} x + y + z = 6 \\\\ 2x - y + z = 3 \\\\ x + 2y - z = 4 \\end{cases}",
    solution: "x = 1, y = 2, z = 3",
    explanation: "用消元法：先消除z，得到關於x,y的二元方程組，再求解。",
    hint: "先選擇一個變數進行消元。",
    difficulty: 3,
    order: 1,
    steps: [
      "方程1+方程2：3x = 9，x = 3（錯誤，重新計算）",
      "方程1+方程3：2x + 3y = 10",
      "方程2-方程1：x - 2y = -3",
      "解二元方程組：x = 1, y = 2",
      "代入得：z = 3"
    ]
  },
  {
    id: "M03_13_002",
    topicId: "M03_13",
    question: "求解對稱三元方程組：\\begin{cases} x + y + z = 9 \\\\ x + y - z = 1 \\\\ x - y + z = 3 \\end{cases}",
    solution: "x = 2, y = 3, z = 4",
    explanation: "利用對稱性：方程1+方程2得2x + 2y = 10，即x + y = 5。類似處理其他組合。",
    hint: "利用方程組的對稱特點。",
    difficulty: 2,
    order: 2,
    steps: [
      "方程1+方程2：2x + 2y = 10，即x + y = 5",
      "方程1+方程3：2x + 2z = 12，即x + z = 6", 
      "方程1-方程2：2z = 8，即z = 4",
      "代入得：x = 2, y = 3",
      "驗證解的正確性"
    ]
  },
  {
    id: "M03_13_003",
    topicId: "M03_13",
    question: "解含參數的三元方程組：\\begin{cases} x + y + z = a \\\\ x + y - z = b \\\\ x - y + z = c \\end{cases}，其中a=6, b=2, c=4。",
    solution: "x = 3, y = 1, z = 2",
    explanation: "代入參數值後，用加減消元法逐步求解。",
    hint: "先代入具體參數值。",
    difficulty: 3,
    order: 3,
    steps: [
      "代入參數：x + y + z = 6, x + y - z = 2, x - y + z = 4",
      "方程1+方程2：2x + 2y = 8，即x + y = 4",
      "方程1+方程3：2x + 2z = 10，即x + z = 5",
      "方程1-方程2：2z = 4，即z = 2",
      "解得：x = 3, y = 1, z = 2"
    ]
  },
  {
    id: "M03_13_004",
    topicId: "M03_13",
    question: "用克拉默法則解：\\begin{cases} 2x + y - z = 1 \\\\ x - y + 2z = 3 \\\\ 3x + 2y + z = 5 \\end{cases}",
    solution: "x = 1, y = -1, z = 1",
    explanation: "計算主行列式D和各個分子行列式Dx, Dy, Dz，然後應用克拉默法則。",
    hint: "需要計算4個三階行列式。",
    difficulty: 4,
    order: 4,
    steps: [
      "計算主行列式D = |2 1 -1; 1 -1 2; 3 2 1|",
      "D = 2(-1-4) - 1(1-6) + (-1)(2+3) = -10 + 5 - 5 = -10",
      "計算Dx = |1 1 -1; 3 -1 2; 5 2 1| = -10",
      "類似計算Dy和Dz",
      "應用克拉默法則求解"
    ]
  },
  {
    id: "M03_13_005",
    topicId: "M03_13",
    question: "解齊次三元方程組：\\begin{cases} x + 2y - z = 0 \\\\ 2x - y + 3z = 0 \\\\ x + 7y - 5z = 0 \\end{cases}",
    solution: "只有零解 x = y = z = 0",
    explanation: "齊次方程組的系數行列式不為零時只有零解。",
    hint: "先判斷系數行列式是否為零。",
    difficulty: 3,
    order: 5,
    steps: [
      "計算係數行列式D",
      "D = |1 2 -1; 2 -1 3; 1 7 -5|",
      "D = 1(5-21) - 2(-10-3) + (-1)(14+1) = -16 + 26 - 15 = -5",
      "D ≠ 0，齊次方程組只有零解",
      "x = y = z = 0"
    ]
  },
  {
    id: "M03_13_006",
    topicId: "M03_13",
    question: "解實際應用題：甲、乙、丙三種商品的價格分別為x、y、z元。已知：買2件甲、1件乙、1件丙共50元；買1件甲、2件乙、1件丙共45元；買1件甲、1件乙、2件丙共55元。求各商品價格。",
    solution: "甲15元，乙10元，丙20元",
    explanation: "建立三元方程組：2x + y + z = 50, x + 2y + z = 45, x + y + 2z = 55，然後求解。",
    hint: "根據題意建立方程組。",
    difficulty: 2,
    order: 6,
    steps: [
      "建立方程組：2x + y + z = 50",
      "x + 2y + z = 45",
      "x + y + 2z = 55",
      "用消元法求解",
      "得到：x = 15, y = 10, z = 20"
    ]
  },
  {
    id: "M03_13_007",
    topicId: "M03_13",
    question: "分析三元方程組\\begin{cases} x + y + z = 1 \\\\ 2x + 2y + 2z = 2 \\\\ 3x + 3y + 3z = 4 \\end{cases}的解的情況。",
    solution: "無解",
    explanation: "前兩個方程等價，但第三個方程與前兩個矛盾（3×1 ≠ 4），所以無解。",
    hint: "檢查方程之間的一致性。",
    difficulty: 2,
    order: 7,
    steps: [
      "第二個方程÷2得：x + y + z = 1",
      "與第一個方程相同",
      "第三個方程÷3得：x + y + z = 4/3",
      "1 ≠ 4/3，矛盾",
      "結論：方程組無解"
    ]
  },
  {
    id: "M03_13_008",
    topicId: "M03_13",
    question: "用高斯消元法解：\\begin{cases} 3x + 2y - z = 7 \\\\ x - y + 2z = 3 \\\\ 2x + 3y + z = 8 \\end{cases}",
    solution: "x = 1, y = 2, z = 0",
    explanation: "將增廣矩陣化為階梯形，然後回代求解。",
    hint: "系統地進行行變換。",
    difficulty: 3,
    order: 8,
    steps: [
      "寫出增廣矩陣：[3 2 -1 | 7; 1 -1 2 | 3; 2 3 1 | 8]",
      "進行行變換化為階梯形",
      "R1↔R2：[1 -1 2 | 3; 3 2 -1 | 7; 2 3 1 | 8]",
      "繼續消元得到階梯形矩陣",
      "回代求解：x = 1, y = 2, z = 0"
    ]
  },
  {
    id: "M03_13_009",
    topicId: "M03_13",
    question: "解含分數的三元方程組：\\begin{cases} \\frac{x}{2} + \\frac{y}{3} + \\frac{z}{6} = 1 \\\\ \\frac{x}{3} + \\frac{y}{2} - \\frac{z}{6} = 0 \\\\ \\frac{x}{6} - \\frac{y}{3} + \\frac{z}{2} = 1 \\end{cases}",
    solution: "x = 2, y = 0, z = 2",
    explanation: "先通分消除分數，轉換為整數係數方程組，然後求解。",
    hint: "找公分母消除分數。",
    difficulty: 3,
    order: 9,
    steps: [
      "各方程乘以6消除分數",
      "得到：3x + 2y + z = 6",
      "2x + 3y - z = 0",
      "x - 2y + 3z = 6",
      "用消元法求解得：x = 2, y = 0, z = 2"
    ]
  },
  {
    id: "M03_13_010",
    topicId: "M03_13",
    question: "求解循環對稱方程組：\\begin{cases} x + 2y + 3z = 14 \\\\ 3x + y + 2z = 11 \\\\ 2x + 3y + z = 13 \\end{cases}",
    solution: "x = 1, y = 3, z = 2",
    explanation: "利用循環對稱性，可以用特殊技巧求解，或用標準消元法。",
    hint: "注意係數的循環對稱特點。",
    difficulty: 3,
    order: 10,
    steps: [
      "觀察係數的循環對稱性：(1,2,3)→(3,1,2)→(2,3,1)",
      "三個方程相加：6x + 6y + 6z = 38",
      "即：x + y + z = 38/6 = 19/3",
      "結合原方程求解",
      "得到：x = 1, y = 3, z = 2"
    ]
  }
];

// M03-14: 方程組建模 (System Modeling)
export const M03_14_PROBLEMS = [
  {
    id: "M03_14_001",
    topicId: "M03_14",
    question: "某工廠生產A、B兩種產品。生產1件A產品需要2小時，生產1件B產品需要3小時。工廠每天有120小時工作時間，要求每天生產的A產品比B產品多10件。求每天生產A、B產品各多少件？",
    solution: "A產品30件，B產品20件",
    explanation: "設每天生產A產品x件，B產品y件。建立方程組：2x + 3y = 120（時間約束），x - y = 10（數量關係）。",
    hint: "分析時間約束和數量關係。",
    difficulty: 2,
    order: 1,
    steps: [
      "設A產品x件，B產品y件",
      "時間約束：2x + 3y = 120",
      "數量關係：x - y = 10",
      "解方程組：x = 30, y = 20",
      "答：A產品30件，B產品20件"
    ]
  },
  {
    id: "M03_14_002",
    topicId: "M03_14",
    question: "小明有50元錢，買了一些5元和8元的商品，共買了7件。問5元和8元的商品各買了多少件？",
    solution: "5元商品2件，8元商品5件",
    explanation: "設5元商品x件，8元商品y件。方程組：x + y = 7（件數），5x + 8y = 50（總價）。",
    hint: "考慮件數和總價兩個約束條件。",
    difficulty: 2,
    order: 2,
    steps: [
      "設5元商品x件，8元商品y件",
      "件數約束：x + y = 7",
      "總價約束：5x + 8y = 50",
      "解方程組：x = 2, y = 5",
      "答：5元商品2件，8元商品5件"
    ]
  },
  {
    id: "M03_14_003",
    topicId: "M03_14",
    question: "某停車場停放汽車和摩托車共100輛，汽車有4個輪子，摩托車有2個輪子，總共有300個輪子。求汽車和摩托車各有多少輛？",
    solution: "汽車50輛，摩托車50輛",
    explanation: "設汽車x輛，摩托車y輛。方程組：x + y = 100（總車數），4x + 2y = 300（總輪數）。",
    hint: "分析車輛數和輪子數的關係。",
    difficulty: 2,
    order: 3,
    steps: [
      "設汽車x輛，摩托車y輛",
      "車輛數：x + y = 100",
      "輪子數：4x + 2y = 300",
      "第二個方程簡化：2x + y = 150",
      "解得：x = 50, y = 50"
    ]
  },
  {
    id: "M03_14_004",
    topicId: "M03_14",
    question: "某班學生參加植樹活動，如果每人植樹3棵，還剩12棵樹苗；如果每人植樹5棵，就缺少8棵樹苗。求班級人數和樹苗總數。",
    solution: "學生10人，樹苗42棵",
    explanation: "設學生x人，樹苗y棵。方程組：3x + 12 = y（第一種情況），5x - 8 = y（第二種情況）。",
    hint: "分析兩種植樹方案的數量關係。",
    difficulty: 2,
    order: 4,
    steps: [
      "設學生x人，樹苗y棵",
      "情況1：3x + 12 = y",
      "情況2：5x - 8 = y",
      "兩式相等：3x + 12 = 5x - 8",
      "解得：x = 10, y = 42"
    ]
  },
  {
    id: "M03_14_005",
    topicId: "M03_14",
    question: "某商店銷售兩種商品，第一種商品利潤率為20%，第二種商品利潤率為30%。如果總投資10000元，期望總利潤為2400元，問兩種商品各投資多少元？",
    solution: "第一種商品6000元，第二種商品4000元",
    explanation: "設第一種商品投資x元，第二種商品投資y元。方程組：x + y = 10000，0.2x + 0.3y = 2400。",
    hint: "考慮投資總額和利潤總額。",
    difficulty: 3,
    order: 5,
    steps: [
      "設第一種商品投資x元，第二種商品投資y元",
      "投資總額：x + y = 10000",
      "利潤總額：0.2x + 0.3y = 2400",
      "第二個方程乘以10：2x + 3y = 24000",
      "解得：x = 6000, y = 4000"
    ]
  },
  {
    id: "M03_14_006",
    topicId: "M03_14",
    question: "甲、乙兩地相距240公里，一輛客車和一輛貨車同時從兩地相向開出，1.5小時後相遇。已知客車速度比貨車速度快20公里/小時，求兩車的速度。",
    solution: "客車90公里/小時，貨車70公里/小時",
    explanation: "設客車速度x公里/小時，貨車速度y公里/小時。方程組：1.5(x + y) = 240，x - y = 20。",
    hint: "分析相遇問題中的距離和速度關係。",
    difficulty: 2,
    order: 6,
    steps: [
      "設客車速度x公里/小時，貨車速度y公里/小時",
      "相遇條件：1.5(x + y) = 240",
      "速度關係：x - y = 20",
      "第一個方程簡化：x + y = 160",
      "解得：x = 90, y = 70"
    ]
  },
  {
    id: "M03_14_007",
    topicId: "M03_14",
    question: "某工程隊計劃用若干天完成一項工程。如果每天多做3個單位工作量，可以提前2天完成；如果每天少做2個單位工作量，要延遲3天完成。求原計劃每天的工作量和完成天數。",
    solution: "原計劃每天15個單位，12天完成",
    explanation: "設原計劃每天x個單位，y天完成。總工作量xy不變，建立方程組。",
    hint: "總工作量保持不變是關鍵。",
    difficulty: 3,
    order: 7,
    steps: [
      "設原計劃每天x個單位，y天完成",
      "總工作量：xy",
      "情況1：(x + 3)(y - 2) = xy",
      "情況2：(x - 2)(y + 3) = xy",
      "展開並解方程組：x = 15, y = 12"
    ]
  },
  {
    id: "M03_14_008",
    topicId: "M03_14",
    question: "某養雞場有雞和兔子共200只，總共有560條腿。求雞和兔子各有多少只？",
    solution: "雞120只，兔子80只",
    explanation: "設雞x只，兔子y只。方程組：x + y = 200（總數），2x + 4y = 560（總腿數）。",
    hint: "經典的雞兔同籠問題。",
    difficulty: 1,
    order: 8,
    steps: [
      "設雞x只，兔子y只",
      "總數：x + y = 200",
      "總腿數：2x + 4y = 560",
      "第二個方程簡化：x + 2y = 280",
      "解得：x = 120, y = 80"
    ]
  },
  {
    id: "M03_14_009",
    topicId: "M03_14",
    question: "某公司生產成本包括固定成本和變動成本。生產100件產品總成本5000元，生產200件產品總成本8000元。求固定成本和單件變動成本。",
    solution: "固定成本2000元，單件變動成本30元",
    explanation: "設固定成本a元，單件變動成本b元。方程組：a + 100b = 5000，a + 200b = 8000。",
    hint: "總成本 = 固定成本 + 變動成本。",
    difficulty: 2,
    order: 9,
    steps: [
      "設固定成本a元，單件變動成本b元",
      "100件：a + 100b = 5000",
      "200件：a + 200b = 8000", 
      "兩式相減：100b = 3000",
      "解得：b = 30, a = 2000"
    ]
  },
  {
    id: "M03_14_010",
    topicId: "M03_14",
    question: "某電影院有甲、乙兩種票價。某天售出甲票150張，乙票100張，票房收入13000元。另一天售出甲票120張，乙票150張，票房收入14400元。求甲、乙兩種票的價格。",
    solution: "甲票60元，乙票40元",
    explanation: "設甲票價格x元，乙票價格y元。方程組：150x + 100y = 13000，120x + 150y = 14400。",
    hint: "根據兩天的銷售情況建立方程組。",
    difficulty: 2,
    order: 10,
    steps: [
      "設甲票x元，乙票y元",
      "第一天：150x + 100y = 13000",
      "第二天：120x + 150y = 14400",
      "化簡第一個方程：3x + 2y = 260",
      "化簡第二個方程：4x + 5y = 480",
      "解得：x = 60, y = 40"
    ]
  }
];

// M03-15: 一致性分析 (Consistency Analysis)
export const M03_15_PROBLEMS = [
  {
    id: "M03_15_001",
    topicId: "M03_15",
    question: "分析方程組\\begin{cases} 2x + 3y = 7 \\\\ 4x + 6y = 14 \\end{cases}的一致性。",
    solution: "一致，有無限多解",
    explanation: "第二個方程是第一個方程的2倍，兩個方程等價，系統一致且有無限多解。",
    hint: "檢查方程之間的比例關係。",
    difficulty: 2,
    order: 1,
    steps: [
      "檢查係數比例：4/2 = 2, 6/3 = 2",
      "檢查常數項比例：14/7 = 2", 
      "所有比例相等",
      "第二個方程 = 2 × 第一個方程",
      "結論：一致，無限多解"
    ]
  },
  {
    id: "M03_15_002",
    topicId: "M03_15",
    question: "判斷方程組\\begin{cases} x + 2y = 5 \\\\ 3x + 6y = 12 \\end{cases}是否一致。",
    solution: "不一致，無解",
    explanation: "係數比例：3/1 = 3, 6/2 = 3，但常數項比例：12/5 = 2.4 ≠ 3，系統不一致。",
    hint: "比較係數比例和常數項比例。",
    difficulty: 2,
    order: 2,
    steps: [
      "係數比例：3/1 = 3, 6/2 = 3",
      "常數項比例：12/5 = 2.4",
      "係數比例相等，常數項比例不等",
      "3 ≠ 2.4",
      "結論：不一致，無解"
    ]
  },
  {
    id: "M03_15_003",
    topicId: "M03_15",
    question: "用增廣矩陣的秩分析方程組\\begin{cases} x + y + z = 1 \\\\ 2x + 2y + 2z = 2 \\\\ 3x + 3y + 3z = 4 \\end{cases}的一致性。",
    solution: "不一致",
    explanation: "係數矩陣的秩為1，增廣矩陣的秩為2，由於秩不相等，系統不一致。",
    hint: "比較係數矩陣和增廣矩陣的秩。",
    difficulty: 3,
    order: 3,
    steps: [
      "寫出增廣矩陣：[1 1 1 | 1; 2 2 2 | 2; 3 3 3 | 4]",
      "行變換：R2-2R1, R3-3R1",
      "得到：[1 1 1 | 1; 0 0 0 | 0; 0 0 0 | 1]",
      "係數矩陣秩為1，增廣矩陣秩為2",
      "結論：不一致"
    ]
  },
  {
    id: "M03_15_004",
    topicId: "M03_15",
    question: "分析含參數方程組\\begin{cases} x + 2y = 3 \\\\ 2x + ky = 6 \\end{cases}在什麼條件下一致。",
    solution: "k = 4時一致",
    explanation: "當k = 4時，第二個方程變為2x + 4y = 6，即x + 2y = 3，與第一個方程相同，系統一致。",
    hint: "找到使兩個方程等價的參數值。",
    difficulty: 2,
    order: 4,
    steps: [
      "要使系統一致，需要第二個方程是第一個方程的倍數",
      "2x + ky = 6 應該等於 2(x + 2y) = 2×3",
      "即：2x + 4y = 6",
      "比較得：k = 4",
      "驗證：當k = 4時系統一致"
    ]
  },
  {
    id: "M03_15_005",
    topicId: "M03_15",
    question: "判斷齊次方程組\\begin{cases} 2x - 3y + z = 0 \\\\ 4x - 6y + 2z = 0 \\\\ 6x - 9y + 3z = 0 \\end{cases}的一致性。",
    solution: "一致，有無限多解",
    explanation: "齊次方程組總是一致的（至少有零解）。此處三個方程成比例，實際上是同一個方程。",
    hint: "齊次方程組總是一致的。",
    difficulty: 2,
    order: 5,
    steps: [
      "齊次方程組總有零解，因此總是一致的",
      "檢查方程關係：方程2 = 2×方程1",
      "方程3 = 3×方程1",
      "三個方程等價",
      "結論：一致，有無限多解"
    ]
  },
  {
    id: "M03_15_006",
    topicId: "M03_15",
    question: "用行列式方法分析方程組\\begin{cases} 3x + 2y = 5 \\\\ 6x + 4y = 7 \\end{cases}的一致性。",
    solution: "不一致",
    explanation: "係數行列式D = 3×4 - 2×6 = 0，但分子行列式Dx = 5×4 - 2×7 = 6 ≠ 0，系統不一致。",
    hint: "當係數行列式為0時，需要檢查分子行列式。",
    difficulty: 3,
    order: 6,
    steps: [
      "計算係數行列式：D = 3×4 - 2×6 = 0",
      "計算Dx = |5 2; 7 4| = 5×4 - 2×7 = 6",
      "D = 0但Dx ≠ 0",
      "根據克拉默法則判斷準則",
      "結論：不一致，無解"
    ]
  },
  {
    id: "M03_15_007",
    topicId: "M03_15",
    question: "分析方程組\\begin{cases} ax + by = c \\\\ dx + ey = f \\end{cases}一致性的一般條件。",
    solution: "ae - bd ≠ 0時一致且有唯一解；ae - bd = 0時需要進一步分析",
    explanation: "當係數行列式不為0時，系統一致且有唯一解。當係數行列式為0時，需要檢查係數和常數項的比例關係。",
    hint: "分情況討論係數行列式的值。",
    difficulty: 4,
    order: 7,
    steps: [
      "情況1：ae - bd ≠ 0，系統一致，有唯一解",
      "情況2：ae - bd = 0，需要進一步分析",
      "若此時係數與常數項成比例，則一致，無限解",
      "若係數成比例但常數項不成比例，則不一致，無解",
      "總結一致性判斷準則"
    ]
  },
  {
    id: "M03_15_008",
    topicId: "M03_15",
    question: "判斷三元方程組\\begin{cases} x + y - z = 2 \\\\ 2x + 2y - 2z = 4 \\\\ x + y - z = 1 \\end{cases}的一致性。",
    solution: "不一致",
    explanation: "第一個方程和第三個方程的左邊相同但右邊不同（2 ≠ 1），系統不一致。",
    hint: "檢查是否有矛盾的方程。",
    difficulty: 2,
    order: 8,
    steps: [
      "觀察第一個和第三個方程",
      "左邊：x + y - z = x + y - z",
      "右邊：2 ≠ 1",
      "出現矛盾",
      "結論：不一致，無解"
    ]
  },
  {
    id: "M03_15_009",
    topicId: "M03_15",
    question: "用高斯消元法分析方程組\\begin{cases} 2x + 3y - z = 1 \\\\ 4x + 6y - 2z = 2 \\\\ 6x + 9y - 3z = 4 \\end{cases}的一致性。",
    solution: "不一致",
    explanation: "通過高斯消元，發現最後一行變為0 = 1的形式，這是矛盾的，所以不一致。",
    hint: "進行行變換，看是否出現矛盾。",
    difficulty: 3,
    order: 9,
    steps: [
      "寫出增廣矩陣並進行行變換",
      "R2 - 2R1：[2 3 -1 | 1; 0 0 0 | 0; 6 9 -3 | 4]",
      "R3 - 3R1：[2 3 -1 | 1; 0 0 0 | 0; 0 0 0 | 1]",
      "最後一行：0 = 1，矛盾",
      "結論：不一致"
    ]
  },
  {
    id: "M03_15_010",
    topicId: "M03_15",
    question: "分析實際問題中方程組的一致性：某商店銷售A、B兩種商品，A商品每件利潤10元，B商品每件利潤15元。如果銷售A商品20件、B商品30件，總利潤650元；銷售A商品40件、B商品60件，總利潤1200元。這個問題的方程組是否一致？",
    solution: "不一致",
    explanation: "建立方程組：20×10 + 30×15 = 650，40×10 + 60×15 = 1200。第二個方程應該是第一個的2倍，但1200 ≠ 2×650，不一致。",
    hint: "建立方程組並檢查一致性。",
    difficulty: 2,
    order: 10,
    steps: [
      "建立方程組：10×20 + 15×30 = 650",
      "10×40 + 15×60 = 1200",
      "即：200 + 450 = 650，400 + 900 = 1200",
      "650 ≠ 650（第一個方程不成立）",
      "實際問題數據有誤，方程組不一致"
    ]
  }
];

// M03-16: 方程構造 (Equation Construction)
export const M03_16_PROBLEMS = [
  {
    id: "M03_16_001",
    topicId: "M03_16",
    question: "構造一個聯立方程組，使其解為 x = 3, y = 2。",
    solution: "例如：\\begin{cases} x + y = 5 \\\\ x - y = 1 \\end{cases}",
    explanation: "將解代入任意兩個線性方程中，確保兩個方程不成比例即可。",
    hint: "選擇簡單的係數，將解代入驗證。",
    difficulty: 2,
    order: 1,
    steps: [
      "選擇第一個方程形式：x + y = ?",
      "代入解：3 + 2 = 5，得x + y = 5",
      "選擇第二個方程形式：x - y = ?", 
      "代入解：3 - 2 = 1，得x - y = 1",
      "驗證：兩方程不成比例，構造成功"
    ]
  },
  {
    id: "M03_16_002",
    topicId: "M03_16",
    question: "構造一個無解的聯立方程組。",
    solution: "例如：\\begin{cases} 2x + 3y = 6 \\\\ 4x + 6y = 15 \\end{cases}",
    explanation: "讓係數成比例但常數項不成比例：4/2 = 6/3 = 2，但15/6 ≠ 2。",
    hint: "係數成比例，常數項不成比例。",
    difficulty: 2,
    order: 2,
    steps: [
      "選擇第一個方程：2x + 3y = 6",
      "讓第二個方程係數成比例：4x + 6y = ?",
      "係數比例為2，常數項應為12才一致",
      "故意選擇不同值：4x + 6y = 15",
      "驗證：15/6 ≠ 2，構造無解方程組成功"
    ]
  },
  {
    id: "M03_16_003",
    topicId: "M03_16",
    question: "構造一個有無限多解的聯立方程組。",
    solution: "例如：\\begin{cases} x + 2y = 4 \\\\ 3x + 6y = 12 \\end{cases}",
    explanation: "讓第二個方程是第一個方程的倍數：第二個方程 = 3 × 第一個方程。",
    hint: "讓兩個方程成比例。",
    difficulty: 2,
    order: 3,
    steps: [
      "選擇第一個方程：x + 2y = 4",
      "讓第二個方程是第一個的3倍",
      "3(x + 2y) = 3×4",
      "得到：3x + 6y = 12",
      "驗證：兩方程等價，有無限多解"
    ]
  },
  {
    id: "M03_16_004",
    topicId: "M03_16",
    question: "構造一個聯立方程組，使其中一個方程通過點(1, 2)和(3, 4)。",
    solution: "通過兩點的方程為 x - y = -1，可構造：\\begin{cases} x - y = -1 \\\\ 2x + y = 7 \\end{cases}",
    explanation: "先求過兩點的直線方程，再添加另一條不平行的直線。",
    hint: "先求過兩點的直線方程。",
    difficulty: 3,
    order: 4,
    steps: [
      "求過(1,2)和(3,4)的直線方程",
      "斜率：k = (4-2)/(3-1) = 2",
      "方程：y - 2 = 2(x - 1)，即2x - y = 1",
      "添加第二個方程：2x + y = 7",
      "驗證：兩直線相交，構造成功"
    ]
  },
  {
    id: "M03_16_005",
    topicId: "M03_16",
    question: "構造一個聯立方程組，使其解滿足 x + y = 10。",
    solution: "例如：\\begin{cases} x + y = 10 \\\\ x - y = 2 \\end{cases}，解為 x = 6, y = 4",
    explanation: "直接用x + y = 10作為一個方程，再添加另一個獨立的方程。",
    hint: "將約束條件作為其中一個方程。",
    difficulty: 2,
    order: 5,
    steps: [
      "第一個方程直接用約束：x + y = 10",
      "選擇第二個方程：x - y = 2",
      "解方程組：x = 6, y = 4",
      "驗證約束：6 + 4 = 10 ✓",
      "構造成功"
    ]
  },
  {
    id: "M03_16_006",
    topicId: "M03_16",
    question: "構造一個齊次聯立方程組，使其有非零解。",
    solution: "例如：\\begin{cases} 2x - 3y = 0 \\\\ 4x - 6y = 0 \\end{cases}",
    explanation: "讓係數行列式為0：第二個方程是第一個方程的2倍，系統有非零解。",
    hint: "讓係數行列式等於0。",
    difficulty: 3,
    order: 6,
    steps: [
      "選擇第一個方程：2x - 3y = 0",
      "讓第二個方程是第一個的倍數：4x - 6y = 0",
      "檢查係數行列式：2×(-6) - (-3)×4 = 0",
      "行列式為0，有非零解",
      "例如：x = 3, y = 2是一個解"
    ]
  },
  {
    id: "M03_16_007",
    topicId: "M03_16",
    question: "構造一個含參數的聯立方程組，使其在 k = 2 時無解，k ≠ 2 時有唯一解。",
    solution: "例如：\\begin{cases} x + y = 3 \\\\ 2x + ky = 5 \\end{cases}",
    explanation: "當k = 2時，係數成比例但常數項不成比例，無解。當k ≠ 2時，有唯一解。",
    hint: "設計參數使得特定值時係數成比例。",
    difficulty: 4,
    order: 7,
    steps: [
      "設計第一個方程：x + y = 3",
      "設計第二個方程：2x + ky = c",
      "當k = 2時要無解：係數比例2/1 = 2/1，但c/3 ≠ 2",
      "選擇c = 5，因為5/3 ≠ 2",
      "驗證：k = 2時無解，k ≠ 2時有唯一解"
    ]
  },
  {
    id: "M03_16_008",
    topicId: "M03_16",
    question: "構造一個聯立方程組來模擬以下實際問題：某商店銷售蘋果和橙子，蘋果每斤5元，橙子每斤3元，總共買了8斤水果，花費36元。",
    solution: "\\begin{cases} x + y = 8 \\\\ 5x + 3y = 36 \\end{cases}",
    explanation: "設蘋果x斤，橙子y斤。第一個方程表示重量約束，第二個方程表示費用約束。",
    hint: "分析問題中的約束條件。",
    difficulty: 2,
    order: 8,
    steps: [
      "設蘋果x斤，橙子y斤",
      "重量約束：x + y = 8",
      "費用約束：5x + 3y = 36",
      "構造方程組完成",
      "解得：x = 6, y = 2（蘋果6斤，橙子2斤）"
    ]
  },
  {
    id: "M03_16_009",
    topicId: "M03_16",
    question: "構造一個三元聯立方程組，使其解為 x = 1, y = 2, z = 3。",
    solution: "例如：\\begin{cases} x + y + z = 6 \\\\ 2x - y + z = 3 \\\\ x + 2y - z = 2 \\end{cases}",
    explanation: "將解代入三個線性無關的方程中，確保係數矩陣可逆。",
    hint: "選擇三個線性無關的方程形式。",
    difficulty: 3,
    order: 9,
    steps: [
      "選擇第一個方程：x + y + z = 1 + 2 + 3 = 6",
      "選擇第二個方程：2x - y + z = 2(1) - 2 + 3 = 3",
      "選擇第三個方程：x + 2y - z = 1 + 2(2) - 3 = 2",
      "檢查係數矩陣行列式不為0",
      "構造成功"
    ]
  },
  {
    id: "M03_16_010",
    topicId: "M03_16",
    question: "構造一個聯立方程組，使其圖形解釋為兩條垂直直線的交點。",
    solution: "例如：\\begin{cases} x = 3 \\\\ y = 2 \\end{cases}",
    explanation: "x = a表示垂直線，y = b表示水平線，它們垂直相交於點(a, b)。",
    hint: "垂直線和水平線的方程形式。",
    difficulty: 2,
    order: 10,
    steps: [
      "垂直線方程：x = 3",
      "水平線方程：y = 2",
      "兩線垂直相交於(3, 2)",
      "這就是方程組的解",
      "幾何意義清晰明確"
    ]
  }
]; 